import { component } from 'flightjs';
import 'jquery';
import memberInfo from 'tradera/legacy/static/app/data/member-info';

function TempData() {
    this._process = function (actions) {
        const tempDataString = this.$node.val();
        const tempData = JSON.parse(tempDataString);

        Object.entries(tempData).forEach(([key, value]) => {
            if (actions[key]) {
                actions[key](value);
            }
        });
    };

    this.after('initialize', function () {
        const actions = {
            justLoggedIn: this._justLoggedIn.bind(this),
            justLoggedInV2: this._justLoggedInV2.bind(this),
            errorMessage: this._errorMessage.bind(this)
        };

        this._process(actions);
    });

    this._justLoggedIn = function (value) {
        if (value) {
            const payload = { memberId: memberInfo.memberId };
            this.trigger(document, 'data:login:logged-in', payload);
        }
    };

    this._justLoggedInV2 = function (value) {
        if (value) {
            const payload = { memberId: memberInfo.memberId, version: 'V2' };
            this.trigger(document, 'data:login:logged-in', payload);
        }
    };

    this._errorMessage = function (value) {
        if (value) {
            const payload = { message: value };
            this.trigger(document, 'ui:error:show', payload);
        }
    };
}

export default component(TempData);
